var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dea28483448b27166235bca137a6ef965b520ce0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["suriname-natural-stone-co-website@tadnv"]={id:"dea28483448b27166235bca137a6ef965b520ce0"};
      